import { mirrorX } from "apparatus/draw";
import { P, Pivot, Polar, R, RP, S, Segments } from "apparatus/library/common";
import { Arrays } from "ext/array";
import { CompoundPath, Group, Path, Shape } from "paper";
export class Solenoid {
    render(appearance) {
        const coilBack = new CompoundPath([]).withStroke("thick");
        coilBack.strokeCap = "round";
        const coilFront = new CompoundPath([]).withStroke("thick");
        coilFront.strokeCap = "round";
        const coilStep = 20;
        const coilHeight = 50;
        const coils = appearance.coils;
        const width = coilStep * coils;
        const coilBackStep = P(coilStep / 2, coilHeight);
        const coilBackStepHandle = coilBackStep.add(P(10, 0));
        const coilFrontStep = P(coilStep / 2, -coilHeight);
        const coilFrontStepHandle = coilFrontStep.add(P(-10, 0));
        for (let i = 0; i < coils; i++) {
            coilBack.moveTo(P(i * coilStep, -coilHeight / 2));
            coilBack.cubicCurveBy(P(10, 0), coilBackStepHandle, coilBackStep);
            coilFront.moveTo(P((i + 0.5) * coilStep, coilHeight / 2));
            coilFront.cubicCurveBy(P(-10, 0), coilFrontStepHandle, coilFrontStep);
        }
        const leftFrontWire = new Path(Segments([[-10, 80]], [[0, -coilHeight / 2], [-15, 0]])).withStroke("thick");
        const rightBackWire = new Path(Segments([[0, -coilHeight / 2], , [15, 0]], [[10, 80]])).withStroke("thick");
        rightBackWire.position.x += width;
        const bar = new Path.Rectangle(R(0, 0, width, coilHeight * 0.74, Pivot.CENTER_LEFT))
            .withStroke("default").withFill("#d7a558");
        const pivot = bar.bounds.center;
        const magneticLines = new Group();
        if (appearance.fieldLines) {
            const magneticLinesCount = 2;
            for (let i = 0; i < magneticLinesCount; i++) {
                // Calculate position within core.
                const y = (magneticLinesCount - i - 0.5) * coilHeight / (2 * (magneticLinesCount + 1));
                const line = new Path([
                    S(P(width / 2, y)),
                    S(P(0, y), P(10, 0), P(-20, 0)),
                    // Point outside the core.
                    S(P(-width * 0.2 * (i + 1), coilHeight * (0.5 + 0.2 * (i + 1) * (coils / 10))), Polar(coilHeight * 0.3 * (coils / 10), -20 - 90).multiply(i + 1), // down
                    Polar(coilHeight * 0.7 * (coils / 10), -20 + 90).multiply(i + 1))
                ]);
                mirrorX(line, width / 2);
                const mirrored = line.clone();
                line.scale(1, -1, P(0, 0));
                magneticLines.addChildren([line, mirrored]);
                const middleOfTheLine = line.getPointAt(line.length * 0.5);
                const arrow = new Path([
                    S(middleOfTheLine),
                    S(middleOfTheLine.add(P(-5, 3))),
                    S(middleOfTheLine.add(P(-5, -3))),
                ]).close().withFill("#3020ff");
                const mirroredArrow = arrow.clone();
                arrow.scale(1, -1, P(0, 0));
                magneticLines.addChildren([arrow, mirroredArrow]);
            }
            magneticLines.withStroke("thin", "#3020ff");
        }
        const graphic = new Group([
            coilBack, rightBackWire, magneticLines,
            ...(appearance.core ? [bar] : []),
            coilFront, leftFrontWire
        ]);
        if (!appearance.core)
            bar.remove();
        return {
            graphic,
            hitShape: Shape.Rectangle(RP(-10, -coilHeight / 2, coils * coilStep + 10, 60)),
            pivot: pivot,
            snapping: [
                { type: "wire", at: leftFrontWire.segments[0].point },
                { type: "wire", at: Arrays.last(rightBackWire.segments).point },
            ]
        };
    }
}
Solenoid.properties = {
    label: "Solenoid",
    flippable: true,
    defaultAppearance: {
        coils: 10,
        fieldLines: false,
        core: true,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "coils", label: "Coils",
            min: 5, max: 15, step: 1,
        },
        { spec: "checkbox-group", label: "Show", checkboxes: [
                { key: "fieldLines", label: "Field lines" },
                { key: "core", label: "Core" },
            ] }
    ],
};
